import { useMutation } from "react-query";
import { AddExpenseAccount } from "../../../../../actions/Utilities/VendorConfiguration";
import { toast } from "components/toastNotification";
import { IExpenseAccount } from "../type";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  addStateExpenseAccount,
  expenseAccountReFetching,
} from "../atoms/atoms";

const useAddExpenseAccounts = () => {
  const setIsAddState = useSetRecoilState(addStateExpenseAccount);
  const [isReFetching, setIsReFetching] = useRecoilState(
    expenseAccountReFetching
  );

  const { mutate } = useMutation(
    (NewData: IExpenseAccount) => AddExpenseAccount(NewData),
    {
      onSuccess: (res: any) => {
        if (typeof res == "object") {
          toast.fire("Adding Expense Account failed", res.Message, "error");
        } else {
          switch (true) {
            case res == "Success":
              toast.fire(
                "Success",
                "Expense Account Added Successfully",
                "success"
              );
              break;
            case res.includes("Notification insert Failed"):
              toast.fire(
                "Success ",
                `Expense Account Added Successfully, BUT ${res}`,
                "warning"
              );
              break;
            case res == "Operation Failed!":
              toast.fire(
                "Adding Expense Account failed ",
                `Server Error: ${res}`,
                "error"
              );
              break;
            case res == "The data already exists!":
              toast.fire(
                "Adding Expense Account failed",
                `Duplication Error: ${res}`,
                "error"
              );
              break;
            default:
              toast.fire("Adding Expense Account failed", res, "error");
          }
        }

        // Redirect to View
        setIsAddState(false);

        // ReFetch Data
        setIsReFetching(isReFetching ? false : true);
      },

      onError: (error: any) => {
        toast.fire("Add Expense Account failed", `Error: ${error}`, "error");
      },
    }
  );

  return mutate;
};
export default useAddExpenseAccounts;
